import clsx from "clsx";
import { useState } from "react";
import useSWR from "swr";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var apiEndpoint = process.env.NEXT_PUBLIC_API_URL || "https://ccq-api.vercel.app";
export default function Tags(_ref) {
  var _tags$data;

  var {
    variant,
    tag,
    setTag
  } = _ref;
  var tags = useSWR(apiEndpoint + "/api/v1/blog/" + variant + "/tags", tagsFetcher);
  var [more, setMore] = useState(false);
  return tags.error || !tags.data ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx("div", {
    className: "pb-2  sticky top-0 bg-white ",
    children: /*#__PURE__*/_jsxs("div", {
      className: clsx(" relative flex  gap-4 overflow-hidden w-full flex-wrap", more ? "overflow-visible" : "overflow-hidden pr-16 h-12"),
      children: [/*#__PURE__*/_jsx("span", {
        onClick: () => {
          setTag({
            name: "",
            id: "all"
          });
          setMore(false);
        },
        className: clsx("p-4 cursor-pointer max-w-xs whitespace-nowrap  grow text-center  flex flex-col justify-center h-12", "all" === (tag == null ? void 0 : tag.id) ? "bg-ccq-yellow font-bold order-first" : "bg-grey/5 order-2"),
        children: "All Articles"
      }), ((_tags$data = tags.data) != null ? _tags$data : []).map((t, tIndex) => /*#__PURE__*/_jsx("span", {
        onClick: () => {
          setTag(t);
          setMore(false);
        },
        className: clsx("p-4 cursor-pointer max-w-xs whitespace-nowrap shadow  grow text-center flex flex-col justify-center h-12 border border-transparent  hover:border-ccq-yellow", t.id === (tag == null ? void 0 : tag.id) ? "bg-ccq-yellow order-first font-bold" : !more && tIndex > 4 ? "hidden" : "order-3 bg-grey/5 h-full"),
        children: t.name
      }, t.id)), /*#__PURE__*/_jsx("div", {
        className: clsx("flex flex-col w-14 justify-center items-center  bg-grey/5  cursor-pointer order-last h-12 border border-transparent  hover:border-ccq-yellow", {
          " h-full absolute right-0 top-0": !more
        }),
        onClick: () => setMore(!more),
        title: more ? "Show Less" : "Show All",
        children: /*#__PURE__*/_jsx("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          strokeWidth: 1.5,
          stroke: "currentColor",
          className: clsx("w-4 h-4 transition-transform duration-1000", more ? "rotate-90" : "-rotate-90"),
          children: /*#__PURE__*/_jsx("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"
          })
        })
      })]
    })
  });
}

var tagsFetcher = url => fetch(url).then(res => res.json()).then(res => res.map(t => {
  return {
    name: t.name,
    id: t.name
  };
}));
//# sourceMappingURL=Tag.js.map